import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { BaseApiService } from '@smartera/core';

@Injectable({
	providedIn: 'root',
})
export class ElasticsearchDataCollectorService extends BaseApiService<any> {
	override get apiUrl() {
		return `${Urls.BASE_URL.toString()}/elasticsearch-data-collector/data-sources`;
	}
}

@Injectable({
	providedIn: 'root',
})
export class ElasticsearchDataCollectorSyncService extends BaseApiService<any> {
	override get apiUrl() {
		return `${Urls.BASE_URL.toString()}/elasticsearch-data-collector/synchronization/logs`;
	}
}
